import React, { useState } from "react";
import styles from "./Otp.module.css";

export const Otp = ({ onSubmit, message }: { onSubmit: (value?: any) => void; message: string}) => {
  const [pinValue, setPinValue] = useState("");

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const enteredValue = event.target.value.replace(/\D/g, "");
    const limitedValue = enteredValue.slice(0, 10);
    setPinValue(limitedValue);
  };

  return (
    <div className={styles.container}>
     <p className={styles.label}>Enter OTP</p>
      <p className={styles.subLabel}>{message}</p>
      <div className={styles.pinContainer}>
        <input
          className={styles.otpBox}
          type="number"
          value={pinValue}
          onChange={handleChange}
          min={1000}
          max={9999999}
        />
        <button
          className={styles.otp_button}
          onClick={() => onSubmit(pinValue)}
          disabled={pinValue.length < 4 || pinValue.length > 10}
        >
          Continue
        </button>
      </div>
    </div>
  );
};
